import { Box, styled } from '@mui/material';

// Banner de la noticia: proporción fija 16/9 (en vez de alturas fijas que, con la
// columna de artículo centrada, dejaban la imagen desproporcionada/acaparadora).
const StyledNewsImageContainer = styled(Box)(({ theme }) => ({
  marginTop: '16px',
  width: '100%',
  aspectRatio: '16 / 9',
  borderRadius: 14,
  overflow: 'hidden',
  border: `1px solid ${theme.palette.hairline.main}`,
  [theme.breakpoints.up('md')]: {
    marginTop: '24px',
    borderRadius: 16
  },
  [theme.breakpoints.up('lg')]: {
    marginTop: '32px'
  }
}));

export default StyledNewsImageContainer;
